import { TFunction } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";

/** The filter categories the dashboard and Control Health panels both offer. */
export type FilterType = "ControlPrograms" | "Tags" | "Entities";

export function localizeFilterType(
    filterType: FilterType,
    t: TFunction
): string {
    switch (filterType) {
        case "Tags":
            return t("Dashboard_TagFilter_Label");
        case "ControlPrograms":
            return t("Dashboard_ControlProgramFilter_Label");
        case "Entities":
            return t("Dashboard_EntityFilter_Label");
        default:
            return assertNever(filterType);
    }
}
